"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var icon_info_provider_service_1 = require("../../../../shared/services/impl/icon-info-provider.service");
var ToIconHrefOrDefaultPipe = /** @class */ (function () {
    function ToIconHrefOrDefaultPipe() {
    }
    /**
     * Value is file extension (string) or icon info.
     */
    ToIconHrefOrDefaultPipe.prototype.transform = function (value) {
        var iconInfo;
        if (typeof value === 'string') {
            iconInfo = icon_info_provider_service_1.IconInfoProviderService.getFileIconInfo(value);
        }
        else {
            iconInfo = value;
        }
        return icon_info_provider_service_1.IconInfoProviderService.getIconPath(iconInfo);
    };
    ToIconHrefOrDefaultPipe = __decorate([
        core_1.Pipe({
            name: 'toIconHrefOrDefault',
            pure: true
        })
    ], ToIconHrefOrDefaultPipe);
    return ToIconHrefOrDefaultPipe;
}());
exports.ToIconHrefOrDefaultPipe = ToIconHrefOrDefaultPipe;
//# sourceMappingURL=to-icon-href.js.map